<mat-progress-bar
  class="custom-progress-bar"
  *ngIf="progressMode == 'determinate'" [mode]="progressMode" [value]="progressValue"></mat-progress-bar>
<mat-progress-bar
  class="custom-progress-bar"
  *ngIf="progressMode == 'indeterminate'" [mode]="progressMode"></mat-progress-bar>
<p class="text-muted !p-0 !m-0" *ngIf="showMessage">{{ message || "Please wait.." }}</p>
<br>
